import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { toast } from "react-hot-toast";
import parse from "html-react-parser";
import Service from "../../components/Services/Service";
import maps from "../../assets/images/maps.png";
import TentangCaready from "../../components/Section/TentangCaready";
import InfoSignUp from "../../components/InfoSignUp/InfoSignUp";
import withoutAuthProvider from "../../services/withoutAuthProvider";

export default function TentangKami() {
  const [dataAbout, setDataAbout] = useState();
  const [firstPart, setFirstPart] = useState();
  const [secondPart, setSecondPart] = useState();
  const [thirdPart, setThirdPart] = useState();
  const [fourthPart, setFourthPart] = useState();
  const [fifthPart, setFifthPart] = useState();

  const [loading, setLoading] = useState(true);

  const toastError = (message) => {
    return toast.error(message, {
      id: "error-message",
      duration: 3000,
    });
  };

  const getData = async () => {
    setLoading(true);
    const response = await withoutAuthProvider.getDataWithoutAuth("/api/about-us");

    // console.log("dummyResponse", dummyResponse);

    if (response?.status === 200) {
      const dat = response?.data.data.data;
      setDataAbout(dat);

      const parts = Object.values(dat);
      const firstPart = parts.find((about) => about.id === 1);
      const secondPart = parts.find((about) => about.id === 2);
      const thirdPart = parts.find((about) => about.id === 3);
      const fourthPart = parts.find((about) => about.id === 4);
      const fifthPart = parts.find((about) => about.id === 5);

      if (firstPart) {
        setFirstPart(firstPart);
      }
      if (secondPart) {
        setSecondPart(secondPart);
      }
      if (thirdPart) {
        setThirdPart(thirdPart);
      }
      if (fourthPart) {
        setFourthPart(fourthPart);
      }
      if (fifthPart) {
        setFifthPart(fifthPart);
      }

      setLoading(false);
    } else {
      toastError(response?.data.message);
    }
  };

  useEffect(() => {
    getData();
  }, []); //eslint-disable-line

  if (loading) {
    return (
      <div className="py-5 font-sm text-secondary text-center">
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  return (
    <div className="page h-100">
      <TentangCaready content={firstPart} />
      <section className="overview pt-0">
        <Container>
          {fourthPart && (
            <Row>
              <Col md={{ span: 6 }}>
                <div className="title">{fourthPart.title}</div>
                <div className="desc mb-2">{parse(fourthPart.description)}</div>
              </Col>
              <Col md={{ span: 6 }}>
                <div className="center-horizontal-vertical mb-2" style={{ height: "100%" }}>
                  <img className="image-overview" alt="Caready Logo" src={fourthPart.file_url} />
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </section>
      <section className="visi-misi">
        <Container>
          <Row>
            <Col md={{ span: 6 }}>
              {thirdPart && (
                <div className="visi-misi-item">
                  <div className="title">{thirdPart.title}</div>
                  <div className="desc">{parse(thirdPart.description)}</div>
                </div>
              )}
            </Col>
            <Col md={{ span: 6 }}>
              {secondPart && (
                <div className="visi-misi-item">
                  <div className="title">{secondPart.title}</div>
                  <div className="desc">{parse(secondPart.description)}</div>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
      <section className="tentang-caready">
        <Container>
          <Row>
            <Col md={{ span: 6 }}>
              <div className="d-flex h-100 align-items-center">
                {/* <img src={careadySplash2} alt="" className="w-100 h-100" /> */}
                {fifthPart && (
                  <>
                    {fifthPart.url ? (
                      <iframe
                        width="420"
                        height="345"
                        className="w-100"
                        src={fifthPart.url}
                        title={fifthPart.title || "Video Tentang Caready"}
                        sandbox="allow-scripts allow-presentation"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        loading="lazy"
                      />
                    ) : fifthPart.file_url ? (
                      <img className="image-overview" alt="Caready Logo" src={fifthPart.file_url} />
                    ) : null}
                  </>
                )}
              </div>
            </Col>
            <Col md={{ span: 6 }}>
              <div className="center-horizontal-vertical" style={{ height: "100%" }}>
                <div>
                  {fifthPart && (
                    <>
                      <div className="title">{fifthPart.title}</div>
                      <div className="desc ">{parse(fifthPart.description)}</div>
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="locations" style={{ background: `url(${maps})` }}>
        <Container>
          <Row>
            <Col md={{ span: 12 }}>
              <div className="title">Caready saat ini tersedia di:</div>
            </Col>
            {dataAbout &&
              dataAbout.location.map((loc, idx) => {
                return (
                  <Col style={{ padding: 12 }} key={`lokasi-${loc.city.id}-${idx}`}>
                    <div className="location">{loc.city.name}</div>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </section>
      <section className="layanan-caready">
        <Container>
          <Row>
            {dataAbout?.service?.length ? (
              <Col md={{ span: 12 }}>
                <div className="title">Layanan Kami</div>
              </Col>
            ) : (
              ""
            )}
            {dataAbout &&
              dataAbout.service.map((lay, idx) => (
                <Col md={{ span: 4 }} key={`layanan-${lay.id || idx}`}>
                  <Service title={lay.title} desc={lay.description} icon={lay.file_url} />
                </Col>
              ))}
          </Row>
        </Container>
      </section>
      <InfoSignUp />
    </div>
  );
}
